var exports = {
  "O": "x234b8571--2d4b53--group",
  "r": "x234b8571--2d4b53--group__item",
};

module.exports = exports;
